export default __webpack_public_path__ + "static/media/pumpkin_soup.3d9692ec.jpg";